import { Component, OnDestroy, OnInit } from '@angular/core';
import { SettingsService } from '../../settings.service';
import { OrganisationPlugins, PlatformSettings } from 'src/app/constants/settings.enum';
import { OrganisationApiClient } from 'src/app/services/organisation.apiclient';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { Subscription } from 'rxjs';
import { OrganisationSettingsApiClient } from 'src/app/services/organisation-settings.apiclient';

@Component({
  templateUrl: './documents.page.html',
  styleUrls: ['./documents.page.css']
})
export class IntegrationsDocumentsPage implements OnDestroy {
  other: OrganisationPlugins[] = [OrganisationPlugins.SharePoint, OrganisationPlugins.OneDrive, OrganisationPlugins.Teams];
  plugins: any[] = [];
  orgSettings: any[] = [];
  organisationIdSubscription: Subscription;
  selectedOrganisationId: string = "";
  organisation!: any;

  constructor(private organisationSettingsApiClient: OrganisationSettingsApiClient, private settingsService: SettingsService, 
    private organisationApiClient: OrganisationApiClient,
    private settingsBreadCrumbService: SettingsBreadCrumbService, private idsForSettingsService: IdsForSettingsService, private identityOrganisationApiClient: IdentityOrganisationApiClient) {
      this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
        if (organisationId === this.selectedOrganisationId) return;
        this.selectedOrganisationId = organisationId;
        // setup specialised breadcrumb
        this.settingsBreadCrumbService.SetOrganisationBasedCrumbs(BreadCrumbOptions.Integrations(this.selectedOrganisationId), BreadCrumbOptions.Integrations_Documents(this.selectedOrganisationId));

        this.getDocumentSettings();
      });
  }

  ngOnDestroy(): void {
    if (this.organisationIdSubscription) {
      this.organisationIdSubscription.unsubscribe();
    }
  }

  getDocumentSettings() {
    this.plugins = [];
    let integrationsDocumentsSettings: PlatformSettings[] = [PlatformSettings.UseAFAS, PlatformSettings.AfasConnectorBaseUrl, PlatformSettings.AfasConnectorToken, PlatformSettings.AfasFTP, PlatformSettings.AfasFTPMultipleFilesOffered, PlatformSettings.AfasFTPUser, PlatformSettings.AfasFTPUserId,
      PlatformSettings.UseClientOnline, PlatformSettings.PinkwebUrl, PlatformSettings.PinkwebUsername, PlatformSettings.PinkwebPassword];

    this.organisationApiClient.getOrganisationSettingsByFilter(this.selectedOrganisationId, integrationsDocumentsSettings).subscribe({
      next: (settings: any) => {
        let returnObject: any = {};
        settings.forEach((setting: any) => {
          returnObject[setting.key] = setting.value;
        });
        this.orgSettings = returnObject;
      }
    });
    this.organisationApiClient.getOrganisationPlugins(this.selectedOrganisationId).subscribe({
      next: (plugins: any) => {
        plugins.sort((a: any, b: any) => a.name.localeCompare(b.name));
        this.organisationApiClient.getEnabledPlugins(this.selectedOrganisationId).subscribe({
          next: (enabledPluginsData: any) => {
            let enabledPlugins: any[] = [];
            for (let i: number = 0; i < enabledPluginsData.length; i++) {
              enabledPlugins.push(enabledPluginsData[i].code);
            }
            for (let i: number = 0; i < plugins.length; i++) {
              let enabled: boolean = false;
              enabled = enabledPlugins.indexOf(plugins[i].code) > -1;
              this.plugins.push({ 'code': plugins[i].code, 'name': plugins[i].name, 'enabled': enabled });
            }
          }
        });
      }
    });
  }

  filterPlugins(codes: OrganisationPlugins[]) {
    let returnObject: { [c: string]: any } = {};
    codes.forEach((code: OrganisationPlugins) => {
      if (this.plugins.findIndex((p: any) => p.code == code) > -1) { returnObject[code] = this.plugins[this.plugins.findIndex((p: { code: any; }) => p.code == code)] }
    });
    return returnObject;
  }

  updateSettings(event: any) {
    this.settingsService.updateSettings(event, this.selectedOrganisationId);
  }

  updatePlugins(event: any) {
    this.settingsService.updatePlugins(event, this.selectedOrganisationId);
  }
}
